const GT = ({ ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M19.8316 5.29998L13.7897 8.47498V12.1569L15.8679 11.0506V13.1856L10.0122 16.5669L5.30599 13.8494C4.95625 13.6474 4.66584 13.357 4.46397 13.0072C4.26209 12.6575 4.15587 12.2607 4.15599 11.8569V6.42311L9.01286 3.61873C9.31652 3.44342 9.66098 3.35112 10.0116 3.35112C10.3622 3.35112 10.7067 3.44342 11.0104 3.61873L15.8672 6.42311L18.8404 4.70623L11.2741 0.337482C10.89 0.116063 10.4544 -0.000488281 10.011 -0.000488281C9.5676 -0.000488281 9.132 0.116063 8.74786 0.337482L1.18286 4.70686V13.57C1.18286 14.395 1.62286 15.1562 2.33661 15.5687L10.0122 20L17.6766 15.575C18.0307 15.3706 18.3247 15.0766 18.5291 14.7226C18.7335 14.3685 18.8411 13.9669 18.841 13.5581V9.46936L19.831 8.94311V5.29998H19.8316Z"
        fill="#D35756"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.507324)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default GT;
